<template>
  <TlLoadingButton
    color="primary"
    variant="solid"
    class="disabled-button place-order-btn h-[48px] w-full !py-3"
    size="lg"
    :complete-text="$t(`common.buttons.place_order`)"
    :disabled="!isValidCheckoutFinal || !hasCheckoutCompleted"
    @click="createOrder"
    >{{ isRequestQuoteFlow ? $t("common.links.request_quote") : $t("common.buttons.place_order") }}
  </TlLoadingButton>
</template>

<script setup lang="ts">
import { useCheckoutFacade } from "../composables/useCheckoutFacade";

const { isValidCheckoutFinal, createOrder, hasCheckoutCompleted, isRequestQuoteFlow } = useCheckoutFacade();
</script>
